module.exports = __webpack_public_path__ + "static/media/m_beard_balbo_diamond__v.f50ea28b.png";